<div class="faq-container">   
        <div class="faq-block">
            <h4 class="title" translate>LEARN_MORE_PAGE.OUR_FAQ</h4>
            <!-- <p translate>LEARN_MORE_PAGE.STUCK</p> -->
            <button routerLink="/faq-shopper"  class="btn btn-outline desktop" translate> HOME_PAGE.ALL_FAQ </button>
            <button routerLink="/faq-shopper"  class="btn btn-outline mobile" translate> HOME_PAGE.ALL_FAQ_MOB </button>
        </div>
        <div class="faq-ques">
            <div class="card">
                <taly-custom-accordion [items]="faqList" />
            </div>
        </div>
    </div>
